var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 696,
    viewBox: "0 0 1440 696",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.158 50.831C444.747 76.3461 128.465 20.4536 0 6.5V656.816C169.295 693.693 344.564 710.891 682.158 678C952.232 651.688 1299.92 658.145 1440 656.816V0C1286.31 6.31234 919.568 25.3158 682.158 50.831Z",
    fill: "url(#paint0_linear_327_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M682.158 50.831C444.747 76.3461 128.465 54.8177 0 40.8641V656.816C169.295 693.693 344.564 689.706 682.158 656.816C952.232 630.503 1299.92 621.267 1440 619.938V0C1286.31 6.31234 919.568 25.3158 682.158 50.831Z",
    fill: "url(#paint1_linear_327_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_327_8",
    x1: 493.5,
    y1: 230.5,
    x2: 720,
    y2: 683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81168C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81168C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_327_8",
    x1: 493.5,
    y1: 230.5,
    x2: 720,
    y2: 683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6610F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.f65919b7adad1d21cba3f2ed3f0b45d5.svg";
export { ForwardRef as ReactComponent };